import styled from '@emotion/styled';
import React from 'react';
import {
  RichImageComponent,
  RichImageComponentProps,
  ImageQueryParams,
} from '../RichImageComponent/RichImageComponent';

export const defaultImageQueryParams: Readonly<ImageQueryParams> = {
  w: '1400',
  fm: 'jpg',
  q: '30',
  fit: 'thumb',
};

export const ArticleImage: React.FC<RichImageComponentProps> = (props) => {
  return (
    <RichImageComponentStyled
      queryParams={defaultImageQueryParams}
      {...props}
    />
  );
};

const RichImageComponentStyled = styled(RichImageComponent)`
  border-radius: 5px;
  height: auto;
  object-fit: cover;
  width: 100%;
  height: 100%;
`;
